import Vue from 'vue';
import ModelComparison from "../components/ModelComparison.vue";

document.addEventListener("DOMContentLoaded", function() {
    if(document.getElementById('vue-modelcomparison')) {
        initModelComparison();
    }
});

window.addEventListener("Pageeditor:insert", function() {
    if(document.getElementById('vue-modelcomparison')) {
        initModelComparison();
    }
});

window.addEventListener("Pageeditor:change", function() {
    if(document.getElementById('vue-modelcomparison')) {
        initModelComparison();
    }
});

function initModelComparison()
{
    new Vue({
        name: 'ModelComparisonRoot',
        el: '#vue-modelcomparison',
        data: () => ({}),
        components: { ModelComparison },
        computed: {},
        methods: {},
        mounted() {},
    });
}